'use strict';

angular.module('licensure.services')
    .factory('CMSSites', ['$http', '$q', '$rootScope', function ($http, $q, $rootScope) {
        return {
            get: function () {
                var d = $q.defer();

                $http.get(apiLocation + '/api/CMSSites', {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            getByEnterprise: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/CMSSites', {
                    params: {
                        enterpriseID: id
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (site) {
                var d = $q.defer();

                var method = 'PUT';
                var url = apiLocation + '/api/CMSSites/' + site.id;

                site.Enterprise_ID = $rootScope.enterpriseID;

                $http({
                    method: method,
                    url: url,
                    data: {
                        site: site
                    }
                }).then(function (response) {
                    d.resolve(response.data);
                }).catch(function (response) {
                    // handle error
                });

                return d.promise;
            }
        }
    }])
;